import React, { useState } from "react";
import { Button, Flex } from "antd";

import { IOvertimeRequestQuery } from "../../models/Hrm";
import { useGetMyOvertime } from "../../query/HrmQuery";

import ModalAddOvertimeRequest from "../../components/modal/hrm/ModalAddOvertimeRequest";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import PersonalOvertimeTable from "../../components/personal/PersonalOvertimeTable";

export const PersonalOvertimeRequests = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const [filter, setFilter] = useState<IOvertimeRequestQuery>({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useGetMyOvertime(filter);

  return (
    <div className="flex-1  p-4 overflow-auto h-full">
      <Flex
        align="center"
        gap="small"
        wrap="wrap"
        className="mb-6 flex justify-between"
      >
        <Button
          type="default"
          size="large"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
        >
          Quay lại
        </Button>
        <Button type="primary" onClick={() => setIsOpen(true)}>
          Thêm mới
        </Button>
      </Flex>
      <PersonalOvertimeTable
        data={data!}
        isLoading={isLoading}
        filter={filter}
        setFilter={setFilter}
      />
      <ModalAddOvertimeRequest
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        query={filter}
      />
    </div>
  );
};
